export default __webpack_public_path__ + "static/media/ico-parking.6a0ac52c.svg";